import axios from 'axios';
import moment from 'moment';
import { main_server_ip } from '../../communication_ips';
import { auth_adminRefresh_router } from '../../communication_router_urls';

let refreshPromise;

const clearAdminSession = () => {
    for (const key of ['refresh_token', 'access_token', 'expires_at', 'user_id', 'user']) {
        localStorage.removeItem(key);
    }
    if (window.location.pathname !== '/login') window.location = '/login';
};

const isRefreshRejected = (error) => [401, 410].includes(error?.response?.status);

const refreshAdminAccessToken = async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
        const error = new Error('관리자 refresh token이 없습니다.');
        error.sessionRejected = true;
        throw error;
    }

    if (!refreshPromise) {
        refreshPromise = axios
            .get(main_server_ip + auth_adminRefresh_router, {
                headers: { Authorization: `Bearer ${refreshToken}` },
            })
            .then((response) => {
                const accessToken = response?.data?.access_token;
                if (response?.status !== 200 || typeof accessToken !== 'string' || !accessToken) {
                    throw new Error('관리자 access token 갱신 응답이 올바르지 않습니다.');
                }
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem('expires_at', moment().add(1, 'hour').format('yyyy-MM-DD HH:mm:ss'));
                return accessToken;
            })
            .finally(() => {
                refreshPromise = undefined;
            });
    }
    return refreshPromise;
};

const refresh_check = async (config) => {
    const refreshToken = localStorage.getItem('refresh_token');
    const expiresAt = localStorage.getItem('expires_at');
    let accessToken = localStorage.getItem('access_token');
    const parsedExpiry = moment(expiresAt);

    // 토큰이 만료되었고, refreshToken 이 저장되어 있을 때
    if ((!accessToken || !parsedExpiry.isValid() || parsedExpiry.diff(moment()) < 0) && refreshToken) {
        try {
            accessToken = await refreshAdminAccessToken();
        } catch (error) {
            if (error.sessionRejected || isRefreshRejected(error)) clearAdminSession();
            throw error;
        }
    }
    config.headers = config.headers || {};
    config.headers['Authorization'] = `Bearer ${accessToken || ''}`;
    return config;
};

const refresh_error_handle = (err) => Promise.reject(err);

export { clearAdminSession, isRefreshRejected, refreshAdminAccessToken, refresh_check, refresh_error_handle };
